import { constants } from '..';
import {
  normalizeExport,
  normalizeExports,
  upsertExport,
} from './download.helpers';

const INITIAL_STATE = {
  xlsLoading: false,
  xmlLoading: false,
  qrLoading: false,
  exportResult: null,
  fileContent: null,
  socket: false,
  exports: [],
  exportsLoading: false,
  exportQueueOpen: false,
  dismissedExportIds: [],
};

export const downloadReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case constants.download.SET_XLS_LOADING:
      return {
        ...state,
        xlsLoading: action.flag,
      };
    case constants.download.CLEAN_DOWNLOAD:
      return {
        ...state,
        fileContent: null,
        exportResult: null,
      };
    case constants.download.SET_DOWNLOADED_FILE:
      return {
        ...state,
        fileContent: action.fileContent,
      };
    case constants.download.SET_XML_LOADING:
      return {
        ...state,
        xmlLoading: action.flag,
      };
    case constants.download.SET_QR_LOADING:
      return {
        ...state,
        qrLoading: action.flag,
      };
    case constants.download.SET_EXPORTS:
      return {
        ...state,
        exports: normalizeExports(action.exports),
      };
    case constants.download.SET_EXPORTS_LOADING:
      return {
        ...state,
        exportsLoading: action.flag,
      };
    case constants.download.TRACK_EXPORT:
    case constants.download.UPSERT_EXPORT: {
      const exportItem = normalizeExport(action.exportItem);

      if (!exportItem) {
        return state;
      }

      const currentExport = state.exports.find(
        item => item.id === exportItem.id
      );
      const nextStatus = exportItem.status;
      const shouldAutoOpen =
        action.type === constants.download.TRACK_EXPORT ||
        (currentExport &&
          currentExport.status !== 'completed' &&
          nextStatus === 'completed');

      return {
        ...state,
        exports: upsertExport(state.exports, exportItem),
        exportQueueOpen: shouldAutoOpen ? true : state.exportQueueOpen,
        dismissedExportIds:
          action.type === constants.download.TRACK_EXPORT ||
          exportItem.status === 'queued' ||
          exportItem.status === 'running'
            ? state.dismissedExportIds.filter(id => id !== exportItem.id)
            : state.dismissedExportIds,
      };
    }
    case constants.download.SET_DISMISSED_EXPORT_IDS:
      return {
        ...state,
        dismissedExportIds: action.ids,
      };
    case constants.download.SET_EXPORT_QUEUE_OPEN:
      return {
        ...state,
        exportQueueOpen: action.isOpen,
      };
    case constants.download.SET_ASYNC_EXPORT_RESULT:
      return {
        ...state,
        exportResult: action.result,
      };
    case constants.download.CONNECT_SOCKET:
      return {
        ...state,
        socket: action.flag,
      };
    case constants.auth.CLEAR_USER:
      return {
        ...INITIAL_STATE,
      };
    default:
      return state;
  }
};
